/* eslint-disable no-redeclare */
import { z } from 'zod';

export const SubId = z.string();

export type SubId = z.infer<typeof SubId>;
